import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => {
  return {
    editor: {
      '& .tiptap': {
        minHeight: 200
      }
    }
  }
})
